import React from 'react';
import { Typography, Box } from '@mui/material';

const UserDetails = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Détails de l'Utilisateur
      </Typography>
      <Typography variant="body1">
        Module de détails des utilisateurs - En cours de développement
      </Typography>
    </Box>
  );
};

export default UserDetails;

